export default __webpack_public_path__ + "static/media/P10020.f08a35e0.png";